/**
 * IMPORTS
 */

import { IAtualizarVendaCreditoPayload } from "@/hooks/vendas-creditos/atualizar-uma-venda/index.d";
import { ICreateVendaCreditosPayload } from "@/hooks/vendas-creditos/criar-venda/index.d";

import {
  IParametrosConsultaCobrancaCreditoCliente,
  IParametrosConsultaExtratoMovimentacoesCreditoCliente,
} from "@/interface/extrato-credito-cliente";
import { managerCreditsRepository } from "@/repositories/vendas-creditos";

const handleExtratoMovimentacoesCreditoCliente = async (
  accessToken: string,
  clienteId: number,
  parametrosConsulta: IParametrosConsultaExtratoMovimentacoesCreditoCliente
) => {
  try {
    const dadosResposta =
      await managerCreditsRepository.getBuscarExtratoMovimentacoesCreditoPorClienteId(
        accessToken,
        clienteId,
        parametrosConsulta
      );

    return dadosResposta;
  } catch (error: unknown) {
    console.log("ERRO AO BUSCAR EXTRATO DE MOVIMENTAÇÕES DE CRÉDITO DO CLIENTE: ", error);

    return error;
  }
};

const handleCobrancaCreditosPorCliente = async (
  accessToken: string,
  clienteId: number,
  parametrosConsulta: IParametrosConsultaCobrancaCreditoCliente
) => {
  try {
    const dadosResposta = await managerCreditsRepository.getBuscarCobrancaCreditosPorClienteId(
      accessToken,
      clienteId,
      parametrosConsulta
    );

    return dadosResposta;
  } catch (error: unknown) {
    console.log("ERRO AO BUSCAR COBRANÇA DE CRÉDITOS DO CLIENTE: ", error);

    return error;
  }
};

const handleMinhaCobrancaCreditos = async (
  accessToken: string,
  parametrosConsulta: IParametrosConsultaCobrancaCreditoCliente
) => {
  try {
    const dadosResposta = await managerCreditsRepository.getBuscarMinhaCobrancaCreditos(
      accessToken,
      parametrosConsulta
    );

    return dadosResposta;
  } catch (error: unknown) {
    console.log("ERRO AO BUSCAR MINHA COBRANÇA DE CRÉDITOS: ", error);

    return error;
  }
};

/**
 * Função que busca transações de créditos do cliente 🛠️.
 */
const handleVendasCteditosPorCliente = async (
  accessToken: string,
  user_cliente_id: number,
  currentPage: number,
  itemsPerPage: number,
  searchItem: string
) => {
  try {
    const data = await managerCreditsRepository.getBuscarVendasCreditos(
      accessToken,
      user_cliente_id,
      currentPage,
      itemsPerPage,
      searchItem
    );

    return data;
  } catch (error: any) {
    console.log("ERROR EM TRANSAÇOES DO CLIENTE: ", error);

    return error;
  }
};

/**
 * Função que busca total de créditos do cliente 🛠️.
 */
const handleVendasTotalCreditosPorCliente = async (
  accessToken: string,
  user_cliente_id: number
) => {
  try {
    const data = await managerCreditsRepository.getBuscarTotalVendasCreditosPorCliente(
      accessToken,
      user_cliente_id
    );

    return data;
  } catch (error: any) {
    console.log("ERROR EM TRANSAÇOES DO CLIENTE: ", error);

    return error;
  }
};

/**
 * Função que criar dados do usuário 🛠️.
 */
const handleCriarVendaCreditos = async (
  accessToken: string,
  payload: ICreateVendaCreditosPayload
) => {
  try {
    const data = await managerCreditsRepository.criarNovaVendaCreditos(accessToken, payload);

    return data;
  } catch (error: any) {
    console.log("ERROR AO COMPARAR CREDITOS PARA CLIENTE: ", error);

    return error;
  }
};

/**
 * Função que atualizar dados da venda de um cliente  🛠️.
 */
const handleAtualizarVendaCredito = async (
  accessToken: string,
  venda_credito_id: number,
  payload: IAtualizarVendaCreditoPayload
) => {
  try {
    const data = await managerCreditsRepository.atualizarVendaCredito(
      accessToken,
      venda_credito_id,
      payload
    );

    return data;
  } catch (error: any) {
    console.log("ERROR AO ATUALIZAR CREDITO PARA CLIENTE: ", error);

    return error;
  }
};

/**
 * Função que cancelar venda de um cliente  🛠️.
 */
const handleCancelarVendaCreditos = async (accessToken: string, venda_credito_id: number) => {
  try {
    const data = await managerCreditsRepository.cancelarVendaCreditos(
      accessToken,
      venda_credito_id
    );

    return data;
  } catch (error: any) {
    console.log("ERROR AO CANCELAR VENDA CREDITO PARA CLIENTE: ", error);

    return error;
  }
};

/**
 * EXPORTS
 */
export {
  handleAtualizarVendaCredito,
  handleCancelarVendaCreditos,
  handleCobrancaCreditosPorCliente,
  handleCriarVendaCreditos,
  handleExtratoMovimentacoesCreditoCliente,
  handleMinhaCobrancaCreditos,
  handleVendasCteditosPorCliente,
  handleVendasTotalCreditosPorCliente,
};
